import { render } from "./Game.vue?vue&type=template&id=44bf8ec0"
const script = {}

import "./Game.vue?vue&type=style&index=0&id=44bf8ec0&scss=true&lang=css"

import exportComponent from "D:\\Project\\skin-web\\觉醒大冒险\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__